import React from "react"
import { Card } from "../../App.styles"
import { RaiseText } from "../../raise-components"
import { InfoIcon, CheckIcon } from "@atos6/icons"
import { Padding, HCenter } from "../../ui"

type Props = {
  disabled: boolean
  done: boolean
  children: React.ReactNode
}

export const CardLayout = ({ disabled, done, children }: Props) => (
  <Card disabled={disabled}>
    <RaiseText
      fontSize="20px"
      fontWeight="600"
      textAlign="center"
      marginBottom="30px">
      Envio de Documentos
    </RaiseText>

    <Padding>
      <HCenter>
        <div style={{ width: 64, height: 64 }}>
          {done ? <CheckIcon /> : <InfoIcon />}
        </div>
      </HCenter>
    </Padding>

    {children}
  </Card>
)
